module.exports = "/365FarmNet/dist/fertilizerPopup.c4a25db573caf166ed2092f0c7c06e74.html";